import {ReceiveOrderData} from "./receive-order.data";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ReceiveOrderEntityModel extends EntityModel<ReceiveOrderData> {
    constructor(injector: Injector) {
        super(injector, ReceiveOrderData);
    }

    override canCreateEntity(): Promise<boolean> {
        return Promise.resolve(false);
    }
}
